import React, { useState, useEffect, useRef } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Host } from '../../App'
import Axios from 'axios'
import './Report.css'
import Print from '../../Common_Files/Print'
const All_Purchase_Requests = () => {
  const [showPrint, setShowPrint] = useState(false)
  const printTableRef = useRef(null)
  var [postList, setPostList] = useState([])
  var [PoNo, setPoNo] = useState({})
  var [poNo, setpoNo] = useState([])
  var [Item_Desc, setItem_Desc] = useState('')
  var [Date1, setDate1] = useState(new Date())
  var [Postartdate, setPoStartdate] = useState('2025-01-01')
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10))
  var [Supplier, setSupplier] = useState({})
  var [Vendor, setVendor] = useState({})
  var [Approval, setApproval] = useState('')
  var [Status, setStatus] = useState({})
  var [Part_No, setPart_No] = useState({})
  var [PO_No, setPO_No] = useState({})
  var [Brand, setBrand] = useState('')
  var [Customers, setCustomers] = useState([])
  var [partNo, setpartNo] = useState([])
  var [Name, setName] = useState({})
  var [Category_list, setCategory_list] = useState([])
  var token = window.localStorage.getItem('acessToken')
  var Stage = window.localStorage.getItem('Stage')
  var Ranked = window.localStorage.getItem('Rank')
  var user = (window.localStorage.getItem('Name') || '').replace(/[{""}]/g, '')
  const [rank, setrank] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [AllColumns, setAllColumns] = useState(false)
  var [del, setdel] = useState('0')
  const [Edit, setEdit] = useState(false)

  const toggleAllColumns = () => {
    setAllColumns(!AllColumns)
  }
  const toggleEdit = () => {
    setEdit(!Edit)
  }
  const urlSplitRegex = /(https?:\/\/[^\s]+)/g
  const urlTestRegex = /^https?:\/\/[^\s]+$/

  const formatMixedText = (text, urlMaxLen = 30) => {
    if (text === null || text === undefined) return ''
    const str = String(text)
    const parts = str.split(urlSplitRegex)
    return parts
      .map((part) => {
        if (urlTestRegex.test(part)) {
          const display = part.length > urlMaxLen ? part.slice(0, urlMaxLen) + '…' : part
          return `<a href="${escapeHtml(part)}" target="_blank" style="color:#007bff;text-decoration:underline;">${escapeHtml(display)}</a>`
        }
        return escapeHtml(part)
      })
      .join('')
  }
  useEffect(() => {
    const role = String(Ranked || '').replaceAll('"', '')
    const stage = String(Stage || '').replaceAll('"', '')
    setrank(role === 'Admin' && (stage === '2' || stage === '3'))
  }, [Ranked, Stage])

  const [data, setData] = useState([])
  const [alldata, setAllData] = useState([])

  const queryParams = {
    token: token,
    Start_date: Postartdate,
    End_date: Poenddate,
    Name: JSON.stringify(Name),
    Item_Desc: JSON.stringify(Item_Desc),
    Brand: JSON.stringify(Brand),
    Vendor: JSON.stringify(Vendor),
    Approval: JSON.stringify(Approval),
    Part_No: JSON.stringify(Part_No),
    PO_No: JSON.stringify(PO_No),
    Supplier: JSON.stringify(Supplier),
    Status: JSON.stringify(Status),
  }

  // ===== helper to update a row locally (for instant color change) =====
  const updateRowLocal = (id, patch) => {
    setData((prev) => prev.map((r) => (r.ID === id ? { ...r, ...patch } : r)))
  }

  // Loaders
  useEffect(() => {
    Axios.get(`https://${Host}/Purchase_Requisitions/alldata`, { params: queryParams }).then((res) => {
      setAllData(res.data)
    })
  }, []) // initial all-data

  useEffect(() => {
    Axios.get(`https://${Host}/api/All_Purchase_Requests/search`, { params: queryParams }).then((res) => {
      setData(res.data)
    })
  }, [Postartdate, Poenddate, Supplier, Brand, Vendor, Name, Item_Desc, Stage, Approval, Part_No, PO_No, del])

  useEffect(() => {
    Axios.get(`https://${Host}/api/All_Purchase_Requests/PONO`, { params: queryParams }).then((res) => {
      setpoNo(res.data)
    })
  }, [])

  const [changedRows, setChangedRows] = useState(new Set())
  const print = () => {
    const changedData = [...changedRows].map((index) => data[index])
    console.log(JSON.stringify(changedData))
  }

  // Actions
  const Approve = (ID) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/approve/${ID},${user},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => setIsLoading(false))
  }

  const Decline = (ID) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/Decline/${ID},${user},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => setIsLoading(false))
  }

  const Status_Change = (ID, newStatus) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/status/${ID},${user},${newStatus},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
        toast.error('Status update failed.', { autoClose: 2500 })
        setdel(String(Number(del) + 1))
      })
      .finally(() => setIsLoading(false))
  }

  const Delete = (ID) => {
    setIsLoading(true)
    Axios.delete(`https://${Host}/Purchase_Requisitions/delete/${ID},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
          })
          setdel(String(Number(del) + 1))
        }
        setEdit(false)
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => setIsLoading(false))
  }

  const PO_No_Change = (ID, PO_No) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/PO_No/${ID},${user},${PO_No},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => setIsLoading(false))
  }

  const Completion_dateChange = (ID, Completion_date) => {
    setIsLoading(true)
    Axios.post(
      `https://${Host}/Purchase_Requisitions/Completion_date/${ID},${user},${Completion_date.slice(0, 10)},${token}`
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => setIsLoading(false))
  }
  const PdfViewer = ({ url }) => {
    const [status, setStatus] = React.useState('loading') // loading | loaded | timeout

    React.useEffect(() => {
      setStatus('loading')
      const timer = setTimeout(() => {
        setStatus((s) => (s === 'loaded' ? s : 'timeout'))
      }, 8000) // if it hasn't fired onLoad in 8s, assume it's stuck
      return () => clearTimeout(timer)
    }, [url])

    return (
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
        {status !== 'loaded' && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#f8f9fa',
            }}
          >
            {status === 'loading' ? (
              <p>Loading PDF…</p>
            ) : (
              <>
                <p>This PDF is taking too long to preview.</p>
                <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                  Open in a new tab instead
                </a>
              </>
            )}
          </div>
        )}
        <iframe
          src={url}
          title="Attachment PDF"
          style={{ width: '100%', height: '100%', border: 'none', visibility: status === 'loaded' ? 'visible' : 'hidden' }}
          onLoad={() => setStatus('loaded')}
        />
      </div>
    )
  }
  const Comment_Change = (ID, Comment) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/Comment/${ID},${user},${Comment},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => {
        setIsLoading(false)
        setEdit(false)
      })
  }

  const Required_Before_Change = (ID, Required_Before) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/Required_Before/${ID},${user},${Required_Before},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => {
        setIsLoading(false)
        setEdit(false)
      })
  }

  const Qty_Change = (ID, Qty) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/Qty/${ID},${user},${Qty},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => {
        setIsLoading(false)
        setEdit(false)
      })
  }

  const Brand_Change = (ID, Brand) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/Brand/${ID},${user},${Brand},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => {
        setIsLoading(false)
        setEdit(false)
      })
  }

  const Vendor_Change = (ID, Vendor) => {
    setIsLoading(true)
    Axios.post(`https://${Host}/Purchase_Requisitions/Vendor/${ID},${user},${Vendor},${token}`)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' },
          })
          setdel(String(Number(del) + 1))
        }
      })
      .catch((error) => {
        console.log(error?.response)
      })
      .finally(() => {
        setIsLoading(false)
        setEdit(false)
      })
  }

  // ===== Duplicate Order Modal state =====
  const [dupModal, setDupModal] = useState({
    open: false,
    row: null,
    form: {
      qty: '',
      required_before: new Date().toISOString().slice(0, 10),
      brand: '',
      unit: '',
      vendor: '',
      comments: '',
    },
  })

  const openDuplicateModal = (row) => {
    const todayISO = new Date().toISOString().slice(0, 10)
    setDupModal({
      open: true,
      row,
      form: {
        qty: row.Qty ?? '',
        required_before: row.Required_Before ? row.Required_Before.slice(0, 10) : todayISO,
        brand: row.Brand || '',
        unit: row.Unit || '',
        vendor: row.Vendor || '',
        comments: row.Comments || '',
      },
    })
  }

  const closeDuplicateModal = () => {
    setDupModal((prev) => ({ ...prev, open: false, row: null }))
  }

  const onDupChange = (e) => {
    const { name, value } = e.target
    setDupModal((prev) => ({ ...prev, form: { ...prev.form, [name]: value } }))
  }

  const submitDuplicate = async () => {
    const row = dupModal.row
    const f = dupModal.form
    if (!f.qty || isNaN(Number(f.qty)) || Number(f.qty) <= 0) {
      toast.error('Enter a valid PO_Qty.', { autoClose: 2500 })
      return
    }
    if (!f.required_before || !/^\d{4}-\d{2}-\d{2}$/.test(f.required_before)) {
      toast.error('Select a valid Required Before date.', { autoClose: 2500 })
      return
    }

    try {
      setIsLoading(true)
      const todayISO = new Date().toISOString().slice(0, 10)
      const fd = new FormData()
      fd.append('token', token || '')
      fd.append('Request_date', todayISO)
      fd.append('name', user || '')
      fd.append('Part_No', row.Part_No || '')
      fd.append('item_description', row.Item_Desc || '')
      fd.append('brand', f.brand || '')
      fd.append('qty', String(f.qty))
      fd.append('unit', f.unit || '')
      fd.append('vendor', f.vendor || '')
      fd.append('required_before', f.required_before)
      fd.append('comments', f.comments || '')

      const resp = await Axios.post(`https://${Host}/add/withoutfile/Purchase_Requisitions`, fd)
      if (resp.status === 200) {
        toast.success('Duplicate order created.', {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },
        })
        setdel(String(Number(del) + 1))
        closeDuplicateModal()
      }
    } catch (err) {
      console.error(err?.response || err)
      toast.error('Failed to create duplicate order.', { autoClose: 3000 })
    } finally {
      setIsLoading(false)
    }
  }

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl)
  }
  const closeModal = () => {
    setSelectedImage(null)
  }

  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modal: {
      position: 'relative',
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      width: 'min(720px, 92vw)',
      maxHeight: '90vh',
      overflowY: 'auto',
      boxShadow: '0 4px 18px rgba(0,0,0,.25)',
    },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
    closeBtn: { border: 'none', background: 'transparent', fontSize: 22, cursor: 'pointer' },
  }

  // ===== GET STATUS COLOR WITH HIGHEST PRIORITY (inline styles) =====
  const getStatusStyle = (val) => {
    const rowStatus = String(val.Status || '').trim()
    const rowApproval = String(val.Approval || '').trim()

    // Default style
    let backgroundColor = '#ffffff'
    let borderLeftColor = 'transparent'
    let borderLeftWidth = '4px'
    let borderLeftStyle = 'solid'

    // Status-based colors (using !important via inline style with high specificity)
    if (rowStatus === 'Pending') {
      backgroundColor = 'rgba(211, 211, 211, 0.25)'
      borderLeftColor = '#b0b0b0'
    } else if (rowStatus === 'Hold') {
      backgroundColor = 'rgba(255, 54, 54, 0.15)'
      borderLeftColor = '#ff3636'
    } else if (rowStatus === 'Ordered') {
      backgroundColor = 'rgba(255, 255, 0, 0.18)'
      borderLeftColor = '#d4d400'
    } else if (rowStatus === 'On going') {
      backgroundColor = 'rgba(255, 165, 0, 0.15)'
      borderLeftColor = '#ff8c00'
    } else if (rowStatus === 'Submitted') {
      backgroundColor = 'rgba(100, 149, 237, 0.15)'
      borderLeftColor = '#6495ed'
    } else if (rowStatus === 'Duplicate') {
      backgroundColor = 'rgba(169, 167, 167, 0.18)'
      borderLeftColor = '#a0a0a0'
    } else if (rowStatus === 'Cancelled') {
      backgroundColor = 'rgba(139, 69, 19, 0.15)'
      borderLeftColor = '#8b4513'
    } else if (rowStatus === 'Partially Received') {
      backgroundColor = 'rgba(245, 245, 220, 0.25)'
      borderLeftColor = '#d4c9a8'
    } else if (rowStatus === 'Completed') {
      backgroundColor = 'rgba(46, 204, 113, 0.15)'
      borderLeftColor = '#2ecc71'
    } else if (rowApproval === 'Declined') {
      backgroundColor = 'rgba(255, 54, 54, 0.15)'
      borderLeftColor = '#cc0000'
    }

    // Return inline styles with !important via style object
    return {
      background: backgroundColor + ' !important',
      borderLeft: borderLeftWidth + ' ' + borderLeftStyle + ' ' + borderLeftColor + ' !important',
      // Add a data attribute for CSS targeting as backup
      'data-status-color': rowStatus || 'default'
    }
  }
  const escapeHtml = (str) => {
    if (str === null || str === undefined) return ''
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }

  const formatPrintDate = (val) => {
    if (!val || val === '0000-00-00') return 'N/A'
    return val.slice(0, 10)
  }

  const buildPrintTableHTML = () => {
    const rows = data
      .map((val) => {
        const currentStatus = String(val.Status || '').trim() || 'N/A'
        const currentApproval = String(val.Approval || '').trim() || 'N/A'
        const timestamp = val.Date
          ? new Date(val.Date).toLocaleString('en-CA', {
            timeZone: 'America/Toronto',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
          : ''

        return `
        <tr>
          <td>${escapeHtml(formatPrintDate(val.Requested_Date))}</td>
          <td>${escapeHtml(timestamp)}</td>
          <td>${escapeHtml(val.Name)}</td>
          <td>${escapeHtml(val.Part_No)}</td>
          <td>${escapeHtml(val.Item_Desc)}</td>
          <td>${escapeHtml(val.Brand)}</td>
          <td>${escapeHtml(val.Qty)}</td>
          <td>${escapeHtml(val.Unit)}</td>
          <td>${escapeHtml(val.Vendor)}</td>
          <td>${escapeHtml(formatPrintDate(val.Required_Before))}</td>
          <td>${formatMixedText(val.Comments)}</td>
          <td>${escapeHtml(currentStatus)}</td>
          <td>${escapeHtml(formatPrintDate(val.Completion_Time))}</td>
          <td>${escapeHtml(currentApproval)}</td>
        </tr>
      `
      })
      .join('')

    const header = `
    <thead>
      <tr>
        <th>Request Date</th>
        <th>Timestamp</th>
        <th>Requested By</th>
        <th>Part No</th>
        <th>Item Description</th>
        <th>Brand</th>
        <th>PO Qty</th>
        <th>Unit</th>
        <th>Vendor</th>
        <th>Required Before</th>
        <th>Comments</th>
        <th>Status</th>
        <th>Completion Date</th>
        <th>Approval</th>
      </tr>
    </thead>
  `

    return `${header}<tbody>${rows}</tbody>`
  }
  return (
    <div className="MainPage_data">
      <div className="Container">
        <ToastContainer />

        <div className="row">
          <div className="col">
            <div className="row">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Requested By"
                list="category"
                onChange={(e) => {
                  setName(e.target.value.replace(/[{""}]/g, ''))
                }}
              />
              <datalist id="category">
                <option></option>
                {[...new Set(alldata.map((x) => x.Name))].map((name, index) => (
                  <option key={index}>{name}</option>
                ))}
              </datalist>
            </div>
          </div>

          <div className="col">
            <div className="row">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Brand"
                list="Brand"
                onChange={(e) => {
                  setBrand(e.target.value)
                }}
              />
              <datalist id="Brand">
                <option></option>
                {[...new Set(alldata.map((x) => x.Brand))].map((Brand, index) => (
                  <option key={index}>{Brand}</option>
                ))}
              </datalist>
            </div>

            <div className="row">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Item Description"
                list="Itemdesc"
                onChange={(e) => {
                  setItem_Desc(e.target.value.replace(/[{"''"}]/g, ''))
                }}
              />
              <datalist id="Itemdesc">
                <option></option>
                {[...new Set(alldata.map((x) => x.Issue_Description))].map((Issue_Description, index) => (
                  <option key={index}>{Issue_Description}</option>
                ))}
              </datalist>
            </div>
          </div>

          <div className="col">
            <div className="row">
              <div className="col" id="moldng">
                <input
                  type="date"
                  className="form-control form-rounded"
                  id="supplychain-button"
                  defaultValue={Postartdate}
                  onChange={(e) => {
                    setPoStartdate(e.target.value)
                  }}
                />
                <span className="tooltiptext">Filter By Request Date</span>
              </div>

              <div className="col">
                <input
                  type="date"
                  className="form-control form-rounded"
                  id="supplychain-button"
                  defaultValue={Date1.toISOString().slice(0, 10)}
                  onChange={(e) => {
                    setPoEnddate(e.target.value)
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col" id="mobileView">
                <button className="btn btn-primary" onClick={toggleAllColumns}>
                  Show All Columns
                </button>
                <button className="btn btn-primary" onClick={toggleEdit}>
                  Edit
                </button>
                <button className="btn btn-primary" onClick={() => setShowPrint(true)}>
                  Print
                </button>
              </div>
              <div className="col" id="mobileView">
                <select
                  className="form-control form-rounded"
                  onChange={(e) => {
                    setApproval(e.target.value)
                  }}
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                </select>
              </div>
            </div>
          </div>

          <div className="col" id="mobileView">
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Vendor"
                  list="Vendor"
                  onChange={(e) => {
                    setVendor(e.target.value)
                  }}
                />
                <datalist id="Vendor">
                  <option></option>
                  {[...new Set(alldata.map((x) => x.Vendor))].map((Vendor, index) => (
                    <option key={index}>{Vendor}</option>
                  ))}
                </datalist>
              </div>

              <div className="col">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Status"
                  list="Status"
                  onChange={(e) => {
                    setStatus(e.target.value)
                  }}
                />
                <datalist id="Status">
                  <option></option>
                  {[...new Set(alldata.map((x) => x.Status))].map((Status, index) => (
                    <option key={index}>{Status}</option>
                  ))}
                </datalist>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Part No"
                  list="Part_No"
                  onChange={(e) => {
                    setPart_No(e.target.value)
                  }}
                />
                <datalist id="Part_No">
                  <option></option>
                  {[...new Set(alldata.map((x) => x.Part_No))].map((Part_No, index) => (
                    <option key={index}>{Part_No}</option>
                  ))}
                </datalist>
              </div>

              <div className="col">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="PO No"
                  list="PO_No"
                  onChange={(e) => {
                    setPO_No(e.target.value)
                  }}
                />
                <datalist id="PO_No">
                  <option></option>
                  {[...new Set(alldata.map((x) => x.PO_No))].map((PO_No, index) => (
                    <option key={index}>{PO_No}</option>
                  ))}
                </datalist>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />

        <div id="RRM_table">
          <table className="table table-hover table-sm" ref={printTableRef}>
            <thead>
              <tr>
                <th>Duplicate</th>
                <th>Request Date</th>
                <th>Timestamp</th>
                <th>Request By</th>
                <th id="mobileView">Part No</th>
                <th>Item Description</th>
                {AllColumns && <th id="mobileView">Brand</th>}
                <th>PO_Qty</th>
                {AllColumns && <th id="mobileView">Unit</th>}
                <th id="mobileView">Vendor</th>
                <th id="mobileView">Required Before</th>
                <th>Attachments</th>
                <th>Comments</th>
                <th>Status</th>
                <th id="mobileView">Tentative/<br />Colmpletion Date</th>
                <th>Approval</th>
                {rank && AllColumns ? <th>Approved By</th> : null}
                {rank ? <th>PO_Number</th> : null}
                {rank ? <th>Approve</th> : null}
                {rank && Edit ? <th id="mobileView">Delete</th> : null}
              </tr>
            </thead>

            <tbody id="All_Req">
              {data.map((val) => {
                const currentStatus = String(val.Status || '').trim()
                const currentApproval = String(val.Approval || '').trim()
                const statusStyle = getStatusStyle(val)

                return (
                  <tr
                    key={val.ID}
                    style={statusStyle}
                    data-status={currentStatus}
                    data-approval={currentApproval}
                    className="status-row"
                  >
                    <td>
                      <button className="btn btn-outline-primary" onClick={() => openDuplicateModal(val)}>
                        Duplicate Order
                      </button>
                    </td>

                    <td>{val.Requested_Date ? val.Requested_Date.slice(0, 10) : ''}</td>
                    <td>
                      {new Date(val.Date).toLocaleString("en-CA", {
                        timeZone: "America/Toronto",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit"
                      })}
                    </td>
                    <td>{val.Name}</td>
                    <td id="mobileView">{val.Part_No}</td>

                    <td className="truncate-hover" title={val.Item_Desc || ''}>
                      {(() => {
                        const text = val.Item_Desc || ''
                        const urlRegex = /(https?:\/\/[^\s]+)/g
                        const parts = text.split(urlRegex)
                        return parts.map((part, idx) => {
                          if (urlRegex.test(part)) {
                            const display = part.length > 30 ? part.slice(0, 30) + '…' : part
                            return (
                              <a
                                key={idx}
                                href={part}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: '#007bff',
                                  textDecoration: 'underline',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {display}
                              </a>
                            )
                          }
                          return <span key={idx}>{part}</span>
                        })
                      })()}
                    </td>

                    {AllColumns ? (
                      ((rank && Edit) || (val.Name === user && currentStatus === 'Submitted')) ? (
                        <td id="mobileView">
                          <input
                            type="text"
                            className="form-control form-rounded"
                            defaultValue={val.Brand}
                            onBlur={(e) => {
                              Brand_Change(val.ID, e.target.value);
                            }}
                          />
                        </td>
                      ) : (
                        <td id="mobileView">{val.Brand}</td>
                      )
                    ) : null}

                    {(rank && Edit) || (val.Name === user && currentStatus === 'Submitted') ? (
                      <td>
                        <input
                          type="number"
                          className="form-control form-rounded"
                          defaultValue={val.Qty}
                          onBlur={(e) => {
                            Qty_Change(val.ID, e.target.value)
                          }}
                        />
                      </td>
                    ) : (
                      <td>{val.Qty}</td>
                    )}

                    {AllColumns && <td id="mobileView">{val.Unit}</td>}

                    {(rank && Edit) || (val.Name === user && currentStatus === 'Submitted') ? (
                      <td id="mobileView">
                        <input
                          type="text"
                          className="form-control form-rounded"
                          defaultValue={val.Vendor}
                          onBlur={(e) => {
                            Vendor_Change(val.ID, e.target.value)
                          }}
                        />
                      </td>
                    ) : (
                      <td id="mobileView">{val.Vendor}</td>
                    )}

                    {(rank && Edit) || (val.Name === user && currentStatus === 'Submitted') ? (
                      <td>
                        <input
                          type="date"
                          className="form-control form-rounded"
                          defaultValue={val.Required_Before ? val.Required_Before.slice(0, 10) : ''}
                          onBlur={(e) => {
                            Required_Before_Change(val.ID, e.target.value)
                          }}
                        />
                      </td>
                    ) : (
                      <td id="mobileView">{val.Required_Before ? val.Required_Before.slice(0, 10) : ''}</td>
                    )}

                    <td>
                      <div id="attachment">
                        {val.File_Link?.length > 1 &&
                          (() => {
                            let attachments = []
                            try {
                              attachments = JSON.parse(val.File_Link)
                              if (!Array.isArray(attachments)) throw new Error('Invalid JSON format')
                            } catch (error) {
                              console.error('Error parsing File_Link:', error)
                              return null
                            }
                            return attachments.map((attachment, index) => (
                              <div key={index}>
                                <a
                                  href={attachment}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-secondary"
                                >
                                  Pic {index + 1}
                                </a>
                              </div>
                            ))
                          })()}
                      </div>

                      {selectedImage && (
                        <div style={modalStyles.overlay} onClick={closeModal}>
                          <div
                            style={{ ...modalStyles.modal, width: 'min(900px, 95vw)' }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div style={modalStyles.header}>
                              <strong>Attachment</strong>
                              <button style={modalStyles.closeBtn} onClick={closeModal}>
                                &times;
                              </button>
                            </div>
                            <a
                              href={selectedImage}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-light"
                              style={{ marginBottom: 10 }}
                            >
                              Download
                            </a>

                            {(() => {
                              const cleanUrl = selectedImage.split('?')[0];
                              const ext = cleanUrl.includes('.')
                                ? cleanUrl.slice(cleanUrl.lastIndexOf('.')).toLowerCase()
                                : '';

                              const imageExts = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'];
                              const pdfExts = ['.pdf'];

                              if (imageExts.includes(ext)) {
                                return (
                                  <img
                                    src={selectedImage}
                                    alt="Attachment Full Size"
                                    style={{ maxWidth: '100%', maxHeight: '70vh' }}
                                  />
                                );
                              }

                              if (pdfExts.includes(ext)) {
                                return <PdfViewer url={selectedImage} />;
                              }

                              return (
                                <div style={{ padding: '30px 10px', textAlign: 'center' }}>
                                  <p>Preview isn't available for this file type ({ext || 'unknown'}).</p>
                                  <p>Use the Download button above to open it.</p>
                                </div>
                              );
                            })()}
                          </div>
                        </div>
                      )}
                    </td>

                    {
                      (rank && Edit) || (val.Name === user && currentStatus === 'Submitted') ? (
                        <td>
                          <input
                            type="text"
                            className="form-control form-rounded"
                            defaultValue={val.Comments}
                            onBlur={(e) => {
                              Comment_Change(val.ID, e.target.value)
                            }}
                          />
                        </td>
                      ) : (
                        <td className="truncate-hover">
                          {(() => {
                            const text = val.Comments || ''
                            const urlRegex = /(https?:\/\/[^\s]+)/g
                            const parts = text.split(urlRegex)
                            return parts.map((part, idx) => {
                              if (urlRegex.test(part)) {
                                const display = part.length > 30 ? part.slice(0, 30) + '…' : part
                                return (
                                  <a key={idx} href={part} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>
                                    {display}
                                  </a>
                                )
                              }
                              return <span key={idx}>{part}</span>
                            })
                          })()}
                        </td>
                      )
                    }

                    <td>
                      {rank || (val.Name === user && currentStatus === 'Submitted') ? (
                        <div className="status-wrapper">
                          <div className="status-text">{currentStatus}</div>

                          <select
                            className="form-control form-rounded status-select"
                            value={currentStatus || 'Submitted'}
                            onChange={(e) => {
                              const newStatus = e.target.value
                              updateRowLocal(val.ID, { Status: newStatus })
                              Status_Change(val.ID, newStatus)
                            }}
                            disabled={!rank && currentApproval !== 'Approved'}
                          >
                            <option value="Submitted">Submitted</option>
                            <option value="Ordered">Ordered</option>
                            <option value="Hold">Hold</option>
                            <option value="Duplicate">Duplicate</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Partially Received">Partially Received</option>
                            <option value="Completed">Completed</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      ) : (
                        currentStatus
                      )}
                    </td>

                    {
                      rank ? (
                        <td id="mobileView">
                          {val.Completion_Time && (currentStatus === 'Completed' || currentStatus === 'Ordered') ? (
                            <input
                              type="date"
                              className="form-control form-rounded"
                              defaultValue={val.Completion_Time.slice(0, 10)}
                              onBlur={(e) => {
                                Completion_dateChange(val.ID, e.target.value)
                              }}
                            />
                          ) : (
                            ''
                          )}
                        </td>
                      ) : (
                        <td>{val.Completion_Time !== '0000-00-00' ? (val.Completion_Time ? val.Completion_Time.slice(0, 10) : 'N/A') : 'N/A'}</td>
                      )
                    }

                    <td>{currentApproval}</td>
                    {rank && AllColumns ? <td>{val.Approved_By}</td> : null}

                    {
                      rank ? (
                        <td>
                          <input
                            type="text"
                            className="form-control form-rounded"
                            list="poNo"
                            defaultValue={val.PO_No === 0 ? '' : val.PO_No ?? ''}
                            onBlur={(e) => {
                              PO_No_Change(val.ID, e.target.value)
                            }}
                          />
                        </td>
                      ) : null
                    }

                    {
                      rank ? (
                        <td>
                          {currentApproval === 'Pending' && (
                            <select
                              className="form-select w-auto"
                              onChange={(e) => {
                                const action = e.target.value
                                if (action === 'approve' && window.confirm('Are you sure you want to Approve?')) {
                                  Approve(val.ID)
                                } else if (action === 'decline' && window.confirm('Are you sure you want to Decline?')) {
                                  Decline(val.ID)
                                }
                              }}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select Action
                              </option>
                              <option value="approve">Approve</option>
                              <option value="decline">Decline</option>
                            </select>
                          )}
                        </td>
                      ) : null
                    }

                    {
                      (rank && Edit) || (val.Name === user && currentStatus === 'Submitted') ? (
                        <td id="mobileView">
                          {currentApproval === 'Approved' || currentStatus === 'Submitted' ? (
                            <button
                              className="btn btn-danger"
                              onClick={() => {
                                window.confirm('Are you sure you want to Delete?') && Delete(val.ID)
                              }}
                            >
                              Delete
                            </button>
                          ) : null}
                        </td>
                      ) : null
                    }
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* ===== Duplicate Order Modal ===== */}
      {
        dupModal.open && (
          <div style={modalStyles.overlay} onClick={closeDuplicateModal}>
            <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
              <div style={modalStyles.header}>
                <strong>Duplicate Purchase Request</strong>
                <button style={modalStyles.closeBtn} onClick={closeDuplicateModal}>
                  &times;
                </button>
              </div>

              {dupModal.row && (
                <div className="mb-3" style={{ fontSize: 14, color: '#555' }}>
                  <div>
                    <b>Part No:</b> {dupModal.row.Part_No}
                  </div>
                  <div>
                    <b>Item:</b> {dupModal.row.Item_Desc}
                  </div>
                  <div>
                    <b>Original Qty:</b> {dupModal.row.Qty} &nbsp; | &nbsp; <b>Requested:</b>{' '}
                    {dupModal.row.Requested_Date ? dupModal.row.Requested_Date.slice(0, 10) : 'N/A'}
                  </div>
                </div>
              )}

              <div className="row g-2">
                <div className="col-md-4">
                  <label className="form-label">PO_Qty</label>
                  <input type="number" min="1" className="form-control" name="qty" value={dupModal.form.qty} onChange={onDupChange} />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Required Before</label>
                  <input type="date" className="form-control" name="required_before" value={dupModal.form.required_before} onChange={onDupChange} />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Unit</label>
                  <input type="text" className="form-control" name="unit" value={dupModal.form.unit} onChange={onDupChange} list="dup-unit" />
                  <datalist id="dup-unit">
                    <option value="" />
                    {[...new Set(alldata.map((x) => x.Unit))].map((Unit, idx) => (
                      <option key={idx}>{Unit}</option>
                    ))}
                  </datalist>
                </div>

                <div className="col-md-4">
                  <label className="form-label">Brand</label>
                  <input type="text" className="form-control" name="brand" value={dupModal.form.brand} onChange={onDupChange} list="dup-brand" />
                  <datalist id="dup-brand">
                    <option value="" />
                    {[...new Set(alldata.map((x) => x.Brand))].map((Brand, idx) => (
                      <option key={idx}>{Brand}</option>
                    ))}
                  </datalist>
                </div>

                <div className="col-md-4">
                  <label className="form-label">Vendor</label>
                  <input type="text" className="form-control" name="vendor" value={dupModal.form.vendor} onChange={onDupChange} list="dup-vendor" />
                  <datalist id="dup-vendor">
                    <option value="" />
                    {[...new Set(alldata.map((x) => x.Vendor))].map((Vendor, idx) => (
                      <option key={idx}>{Vendor}</option>
                    ))}
                  </datalist>
                </div>

                <div className="col-12">
                  <label className="form-label">Comments</label>
                  <textarea rows="3" className="form-control" name="comments" value={dupModal.form.comments} onChange={onDupChange} />
                </div>
              </div>

              <div className="mt-3 d-flex gap-2">
                <button className="btn btn-primary" onClick={submitDuplicate}>
                  Create Duplicate
                </button>
                <button className="btn btn-light" onClick={closeDuplicateModal}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )
      }
      {showPrint && (
        <Print
          tableHTML={buildPrintTableHTML()}
          title="All Purchase Requests"
          onComplete={() => setShowPrint(false)}
        />
      )}
      {
        isLoading ? (
          <div className="overlay">
            <div className="loading-container">
              <div className="loading-dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
              <p className="loading">Loading</p>
            </div>
          </div>
        ) : null
      }
    </div >
  )
}

export default All_Purchase_Requests